module.exports = __webpack_public_path__ + "img/icon-question.0a35d794.svg";